var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Lib
import React, { lazy, Suspense } from "react";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import API from "../lib/API";
var AsyncSelect = lazy(function () { return import('react-select/async'); });
import { components } from "react-select";
var searchVenuesDebounced = AwesomeDebouncePromise(API.searchPlaceFromGoogle, 500);
var VenueSearch = /** @class */ (function (_super) {
    __extends(VenueSearch, _super);
    function VenueSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputValue: '',
            selectedVenue: null,
            selectedOption: null,
            venueSelected: false,
            defaultOptions: [],
            alreadyExists: false,
            existsURL: '',
        };
        _this.sessionToken = null;
        _this.componentDidMount = function () {
            _this.sessionToken = window.googlePlacesSessionID || null;
            document.addEventListener('keydown', function (ev) {
                if (ev.key === "`" || ev.key === "Super") {
                    debugger;
                }
            });
        };
        _this.optionLabel = function (data) {
            var string = "\n            <span>".concat(data.label, "</span>\n            <span class=\"second-line\">").concat(data.structured_formatting.secondary_text, "</span>\n        ");
            return (React.createElement("span", { dangerouslySetInnerHTML: { __html: string } }));
        };
        _this.getRestaurants = function (inputValue) { return __awaiter(_this, void 0, void 0, function () {
            var results, newResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, searchVenuesDebounced(inputValue)];
                    case 1:
                        results = _a.sent();
                        newResults = results.map(function (result) {
                            return __assign(__assign({}, result), { value: result.place_id, label: result.structured_formatting.main_text });
                        });
                        this.setState({ defaultOptions: newResults });
                        return [2 /*return*/, newResults];
                }
            });
        }); };
        _this.formatAddressFromComponent = function (component) {
            var addressObj = {};
            var addressLine1 = '';
            var addressLine2 = '';
            var addressLine3 = '';
            var county = '';
            var postcode = '';
            component.forEach(function (el) {
                addressObj[el.types[0]] = el.long_name;
            });
            if (typeof addressObj.subpremise !== 'undefined')
                addressLine1 += "".concat(addressObj.subpremise, " ");
            if (typeof addressObj.premise !== 'undefined')
                addressLine1 += "".concat(addressObj.premise, " ");
            if (!addressLine1.length) {
                if (typeof addressObj.street_number !== 'undefined')
                    addressLine1 += "".concat(addressObj.street_number, " ");
                if (typeof addressObj.route !== 'undefined')
                    addressLine1 += "".concat(addressObj.route, " ");
                if (typeof addressObj.postal_town !== 'undefined')
                    addressLine2 += "".concat(addressObj.postal_town, " ");
            }
            else {
                if (typeof addressObj.street_number !== 'undefined')
                    addressLine2 += "".concat(addressObj.street_number, " ");
                if (typeof addressObj.route !== 'undefined')
                    addressLine2 += "".concat(addressObj.route, " ");
                if (addressLine2.length) {
                    if (typeof addressObj.postal_town !== 'undefined')
                        addressLine3 += "".concat(addressObj.postal_town, " ");
                }
                else {
                    if (typeof addressObj.postal_town !== 'undefined')
                        addressLine2 += "".concat(addressObj.postal_town, " ");
                }
            }
            if (typeof addressObj.administrative_area_level_2 !== 'undefined')
                county += "".concat(addressObj.administrative_area_level_2, " ");
            if (typeof addressObj.postal_code !== 'undefined')
                postcode += "".concat(addressObj.postal_code, " ");
            return {
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                addressLine3: addressLine3,
                county: county,
                postcode: postcode
            };
        };
        _this.setAddress = function (resp) {
            if (resp.exists && !_this.props.allowExists) {
                _this.props.onVenueExists("/?post_type=venue&p=".concat(resp.id));
            }
            var venueObj = {
                address: resp.address || {},
                website: resp.website || '',
                name: resp.name || '',
                telephoneNumber: resp.telephoneNumber || '',
                image: resp.imageID || '',
                id: resp.id || ''
            };
            _this.setState({
                venueSelected: true,
                inputValue: resp.name || ''
            }, function () {
                _this.props.form.setFieldValue('venue', venueObj);
                _this.props.onVenueSelected(resp);
                // if(typeof resp.photos !== 'undefined' && resp.photos.length){
                //     this.props.onVenueImage(resp.photos[0]);
                // }
            });
        };
        _this.clearAddress = function () {
            var defaultVenue = {
                name: '',
                address: {
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    county: '',
                    postcode: '',
                    latLng: ''
                },
                website: '',
                telephoneNumber: '',
                description: '',
            };
            _this.setState({
                venueSelected: false,
                selectedOption: null
            }, function () {
                _this.props.form.setFieldValue('venue', defaultVenue);
                _this.props.onVenueCleared();
            });
        };
        _this.onChange = function (selectedOption) {
            if (selectedOption === null) {
                _this.clearAddress();
                return;
            }
            var selected = selectedOption;
            if (selected.value === 'not-found') {
                _this.setState({
                    selectedOption: selected
                }, function () { return _this.props.onManualInput(); });
            }
            else {
                _this.setState({ selectedOption: selected });
                API.getVenuePlaceholder(selected.place_id)
                    .then(_this.setAddress)
                    .catch(function (err) {
                    if (err.code === 'already-exists') {
                        var data = err.data;
                        _this.props.onVenueExists(data === null || data === void 0 ? void 0 : data.post_url);
                    }
                });
            }
        };
        _this.noResultsText = function (inputValue) {
            if (inputValue == null || !inputValue.length)
                return '';
            return "No Results Found";
        };
        _this.setInputValue = function (value, actionMeta) {
            if (actionMeta.action === "set-value" ||
                actionMeta.action === "input-blur" ||
                actionMeta.action === "menu-close") {
                return;
            }
            _this.setState({ inputValue: value });
        };
        _this.render = function () {
            var DropdownIndicator = function (props) {
                return React.createElement(components.DropdownIndicator, __assign({}, props),
                    React.createElement("svg", null,
                        React.createElement("use", { xlinkHref: "#icon--search" })));
            };
            var ClearIndicator = function (props) {
                return React.createElement(components.ClearIndicator, __assign({}, props),
                    React.createElement("svg", null,
                        React.createElement("use", { xlinkHref: "#icon--close" })));
            };
            var NoOptionsMessage = function (props) {
                return props.hasValue ? (React.createElement(components.NoOptionsMessage, __assign({}, props),
                    React.createElement("span", { className: "custom-css-class" }, "No Results Found"))) : null;
            };
            var LoadingMessage = function (props) {
                return React.createElement(components.LoadingMessage, __assign({}, props),
                    React.createElement("div", { className: "loading loading--small" },
                        React.createElement("svg", { className: "loading-animation loading__icon" },
                            React.createElement("use", { xlinkHref: "#icon--loading" }))));
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(Suspense, { fallback: React.createElement("div", { className: "form__control" }) },
                    React.createElement(AsyncSelect, { inputId: "restaurant-google-lookup", loadOptions: _this.getRestaurants, defaultOptions: _this.state.defaultOptions, cacheOptions: true, 
                        // inputValue={ this.state.inputValue }
                        onInputChange: _this.setInputValue, formatOptionLabel: _this.optionLabel, value: _this.state.selectedOption, onChange: _this.onChange, isClearable: true, placeholder: "Find venue here", className: "react-select-search", classNamePrefix: "react-select-search", components: { DropdownIndicator: DropdownIndicator, ClearIndicator: ClearIndicator, NoOptionsMessage: NoOptionsMessage, LoadingMessage: LoadingMessage } }))));
        };
        return _this;
    }
    return VenueSearch;
}(React.PureComponent));
export default VenueSearch;
